import React from "react";
import {connect} from "react-redux";
import {StyleSheet, Text, TouchableOpacity, View} from "react-native";
import AvatarIcon from "../../Header/AvatarIcon";
import {compose} from "redux";
import {withTranslation} from "react-i18next";

class PostCitation extends React.Component{
    constructor(props) {
        super(props);
    }

    render() {
        const styles = StyleSheet.create({
            citationContainer:{
                marginTop:15,
                marginBottom:15,
            },
            nomCitation:{
                color : this.props.theme.colors.tertiary.black6.value,
                fontFamily:this.props.theme.fonts.text,
                fontWeight:"600",
                fontSize:13,
            },
            citationAvatarContainer:{
                flexDirection:"row",
                marginTop:7
            },
        });

        let contact = this.props.citationsContact.slice(0,5);
        let Entitys = this.props.citationsEntity.slice(0,5);
        if(contact.length==0 && Entitys.length==0){
            return <View></View>
        }
        return(

                <View style={styles.citationContainer}>
                    {!this.props.isExplorer && false && <Text>

                        {contact.map((citation,index)=>{
                            return <TouchableOpacity key={index} onPress={()=>{this.props._navigateToEntityScreen(citation,"contact")}}><Text key={Math.random()} style={styles.nomCitation}>{citation.firstname} {citation.lastname.toUpperCase()}{ (index!=4 &&  index!==contact.length-1 )? ", ":""}</Text></TouchableOpacity>;
                        })}
                        {Entitys.map((Entity,index)=>{
                            return <TouchableOpacity key={index} onPress={()=>{this.props._navigateToEntityScreen(Entity,'entity')}}><Text key={Math.random()} style={styles.nomCitation}> {Entity.name.toUpperCase()}{ (index!=4 &&  index!==Entitys.length-1 )? ", ":""}</Text></TouchableOpacity>;
                        })}
                        {contact.length + Entitys.length<=5 && <Text style={styles.nomCitation}> {this.props.t('sont cités')}</Text>}
                        {contact.length + Entitys.length >5 && <Text style={styles.nomCitation}> {this.props.t('et d\'autres sont cités')} </Text>}
                    </Text> }
                    <View style={styles.citationAvatarContainer}>
                    {contact.map((citation,index)=>{
                        return <TouchableOpacity key={index} onPress={()=>{this.props._navigateToEntityScreen(citation,"contact")}}>{(citation.icon!="") ?  <AvatarIcon style={{width:38,height:38,borderWidth:0,borderRadius:13,marginRight:7}} key={index} icon={citation.img}/> : <AvatarIcon/>}</TouchableOpacity>
                    })}
                        {Entitys.map((Entity,index)=>{
                            return <TouchableOpacity key={index} onPress={()=>{this.props._navigateToEntityScreen(Entity,'entity')}}>{(Entity.icon!="") ?  <AvatarIcon style={{width:38,height:38,borderWidth:0,borderRadius:13,marginRight:7}} key={index} icon={Entity.img}/> : <AvatarIcon/>}</TouchableOpacity>
                        })}
                    </View>
                </View>
        );
    }
}

const mapStateToProps = (state) => {
    return {isDark: state.changeTheme.isDark,theme: state.changeTheme.theme, auth : state.AuthReducer};
}

export default compose(withTranslation(),connect(mapStateToProps))(PostCitation);
